/* Unpublished campaign pages share BIO's native cart and checkout. */
(() => {
  'use strict';
  const script = document.currentScript;
  const root = document.querySelector('#paid-offers');
  const builderBar = root?.querySelector('.offer-builder-bar');
  let refreshChatPosition = () => {};
  if (typeof ResizeObserver !== 'undefined') {
    const chatUpdates = new Set();
    refreshChatPosition = () => chatUpdates.forEach(update => update());
    const updateChatOffset = () => document.body.style.setProperty('--bio-builder-height', `${builderBar?.offsetHeight || 0}px`);
    if (builderBar) new ResizeObserver(updateChatOffset).observe(builderBar);
    updateChatOffset();
    // Position the actual widget directly; Safari and late vendor styles must
    // not depend on :has() or Richpanel's inconsistent closed class.
    const watchedChat = new WeakSet();
    const watchChat = () => {
      for (const frame of document.querySelectorAll('#richpanel_messenger_iframe, .rp-micro-app-dummy-icon-container')) {
      if (watchedChat.has(frame)) continue;
      watchedChat.add(frame);
      const originalBottom = frame.style.bottom || '0px';
      const updateChatState = () => {
        const expanded = frame.offsetHeight > 200;
        const vaultBar = document.querySelector('#bi-vault-bar');
        const bar = builderBar?.dataset.builderVisible === 'true' ? builderBar : vaultBar;
        const active = matchMedia('(max-width:720px)').matches && bar && bar.getBoundingClientRect().height > 0;
        // Compare both elements in the same viewport coordinates. Safari's
        // collapsing browser chrome can move fixed widgets during scrolling.
        const currentBottom = parseFloat(getComputedStyle(frame).bottom) || 0;
        const clearance = active ? bar.getBoundingClientRect().top - frame.getBoundingClientRect().bottom : 0;
        const bottom = active && !expanded ? `${Math.max(0, Math.ceil(currentBottom + 12 - clearance))}px` : originalBottom;
        if (frame.dataset.bioChatExpanded !== String(expanded)) frame.dataset.bioChatExpanded = String(expanded);
        const priority = active ? 'important' : '';
        if (frame.style.bottom !== bottom || frame.style.getPropertyPriority('bottom') !== priority) {
          frame.style.setProperty('bottom', bottom, priority);
        }
      };
      new ResizeObserver(updateChatState).observe(frame);
      chatUpdates.add(updateChatState);
      if (builderBar) new ResizeObserver(updateChatState).observe(builderBar);
      new MutationObserver(updateChatState).observe(frame, {attributes:true, attributeFilter:['style','class']});
      if (builderBar) new MutationObserver(updateChatState).observe(builderBar, {attributes:true, attributeFilter:['data-builder-visible']});
      window.addEventListener('resize', updateChatState);
      window.addEventListener('scroll', updateChatState, {passive:true});
      window.visualViewport?.addEventListener('resize', updateChatState);
      window.visualViewport?.addEventListener('scroll', updateChatState, {passive:true});
      updateChatState();
      }
    };
    watchChat();
    new MutationObserver(watchChat).observe(document.body, {childList:true, subtree:true});
  }
  const views = {buy10get5:'buy-10-get-5',pack15:'15-for-30',vault:'mystery-seed-vault'};
  const storageKey = 'bio-seed-offer-' + (script?.dataset.theme || 'draft');
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents / 100);
  const escape = value => String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let state = null, data, queue = Promise.resolve(), syncTimer;
  try { state = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
  if (!views[state?.offer]) state = null;
  const saveState = () => { try { if(state)sessionStorage.setItem(storageKey,JSON.stringify(state));else sessionStorage.removeItem(storageKey); } catch {} };
  if (root?.dataset.legacy) {
    const url = new URL(location.href);
    const offer = url.searchParams.get('offer');
    url.searchParams.set('view', views[offer] || views.buy10get5);
    url.searchParams.delete('offer');
    location.replace(url.toString());
    return;
  }
  const pageOffer = root?.dataset.offer;
  const $ = id => root?.querySelector('#'+id);
  let dataPromise;
  async function catalog() {
    if (!dataPromise) dataPromise = fetch(script?.dataset.catalog || root.dataset.catalog).then(r=>{if(!r.ok)throw new Error('The seed collection could not load. Please refresh and try again.');return r.json()}).then(result=>data=result).catch(error=>{dataPromise=null;throw error});
    return dataPromise;
  }
  async function api(path, body) {
    const response = await fetch('/'+path, body === undefined ? {cache:'no-store'} : {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const result = await response.json();
    if(!response.ok)throw new Error(result.description || result.message || 'Your cart could not be updated. Please try again.');
    return result;
  }
  const isGift = item => item.properties?._bi_paid_offer_gift === 'vault';
  const merchandiseSubtotal = cart => cart.items.filter(i=>!isGift(i)&&String(i.product_id)!==String(data.offers.vault.giftProductId)).reduce((sum,i)=>sum+i.original_line_price,0);
  function cartMessage(message) {
    let notice = document.querySelector('[data-bi-offer-notice]');
    if(!notice){const host=document.querySelector('[data-mini-cart]');if(!host)return;notice=document.createElement('p');notice.dataset.biOfferNotice='';notice.setAttribute('role','alert');host.prepend(notice);}
    notice.textContent=message;notice.hidden=!message;
  }
  function renderGiftProgress(cart) {
    const remaining=Math.max(0,data.offers.vault.threshold-merchandiseSubtotal(cart));
    const giftInCart=cart.items.some(isGift);
    renderVaultBar(remaining,giftInCart);
    if($('vault-progress'))$('vault-progress').textContent=remaining?`${money(remaining)} away from your free flower seed bundle.`:giftInCart?'Gift unlocked - your seed surprise is in your cart.':'Your cart qualifies - claim your free seed gift.';
    if($('vault-meter')){$('vault-meter').value=data.offers.vault.threshold-remaining;$('vault-meter').setAttribute('aria-valuetext',remaining?`${money(remaining)} remaining`:'Gift threshold reached');}
    if($('claim-gift'))$('claim-gift').hidden=remaining>0||giftInCart;
  }
  function publishCart(cart) {
    window.dispatchEvent(new CustomEvent('cart:changed',{detail:{cart,source:'paid-seed-offer'}}));
  }
  async function syncCart(activateOffer) {
    await catalog();
    let cart=await api('cart.js'), changed=false;
    // The cart is shared across tabs; sessionStorage is not. Restore the offer
    // from the actual entered code so new tabs never lose gift reconciliation.
    if(!activateOffer&&Array.isArray(cart.discount_codes)){
      const currentOffer=Object.keys(views).find(offer=>cart.discount_codes.some(d=>d.code.toUpperCase()===data.offers[offer].code.toUpperCase() && (offer==='vault'||d.applicable!==false)));
      state=currentOffer?{offer:currentOffer,codeSeen:true}:null;
      saveState();
    }
    if(activateOffer){state={offer:activateOffer,codeSeen:false};saveState();}
    const code=state?data.offers[state.offer].code:null;
    const hasCode=code&&cart.discount_codes?.some(d=>d.code.toUpperCase()===code.toUpperCase());
    // Respect an explicitly removed coupon; do not continually force it back.
    if(!activateOffer&&state?.codeSeen&&Array.isArray(cart.discount_codes)&&!hasCode){state=null;saveState();}
    const wanted=state?.offer==='vault'&&merchandiseSubtotal(cart)>=data.offers.vault.threshold;
    const gifts=cart.items.filter(isGift);
    for(let i=0;i<gifts.length;i++){
      const quantity=wanted&&i===0?1:0;
      if(gifts[i].quantity!==quantity){await api('cart/change.js',{id:gifts[i].key,quantity});changed=true;}
    }
    if(wanted&&!gifts.length){
      const gift=data.offers.vault;
      const product=await api('products/'+gift.giftHandle+'.js');
      if(!product.variants.some(v=>v.id===gift.giftVariantId&&v.available))throw new Error('The seed gift is currently unavailable. Please remove this offer or try again later.');
      await api('cart/add.js',{items:[{id:gift.giftVariantId,quantity:1,properties:{_bi_paid_offer_gift:'vault'}}]});changed=true;
    }
    if(activateOffer){
      // Replace campaign codes while preserving other codes (including shipping).
      const offerCodes=Object.keys(views).map(offer=>data.offers[offer].code.toUpperCase());
      const retainedCodes=(cart.discount_codes||[]).map(d=>d.code).filter(code=>!offerCodes.includes(code.toUpperCase()));
      await api('cart/update.js',{discount:''});
      cart=await api('cart/update.js',{discount:[...retainedCodes,data.offers[activateOffer].code].join(',')});
      changed=true;
    }
    else if(changed)cart=await api('cart.js');
    // An entered but rejected vault code must not leave a chargeable gift.
    const vaultCode=cart.discount_codes?.find(d=>d.code.toUpperCase()===data.offers.vault.code.toUpperCase());
    if(state?.offer==='vault' && vaultCode?.applicable===false){
      for(const gift of cart.items.filter(isGift)){
        await api('cart/change.js',{id:gift.key,quantity:0});changed=true;
      }
      cart=await api('cart.js');
    }
    if(state&&cart.discount_codes?.some(d=>d.code.toUpperCase()===data.offers[state.offer].code.toUpperCase())){state.codeSeen=true;saveState();}
    renderGiftProgress(cart);
    if(changed)publishCart(cart);
    cartMessage('');
    return cart;
  }
  function enqueue(action){const task=queue.then(action);queue=task.catch(()=>{});return task;}
  function scheduleSync(){clearTimeout(syncTimer);syncTimer=setTimeout(()=>enqueue(()=>syncCart()).catch(error=>cartMessage(error.message)),100);}
  window.addEventListener('cart:changed',event=>{if(event.detail?.source==='paid-seed-offer')return;if(data&&event.detail?.cart)renderGiftProgress(event.detail.cart);scheduleSync();});
  // Complete gift reconciliation before the standard cart enters checkout.
  document.addEventListener('click',event=>{
    const checkout=event.target.closest?.('[name="checkout"], [data-cart-page-checkout], a[href^="/checkout"]');
    if(!checkout)return;
    event.preventDefault();event.stopImmediatePropagation();
    enqueue(()=>syncCart()).then(()=>location.assign('/checkout')).catch(error=>cartMessage(error.message));
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!new URL(form.action,location.href).pathname.match(/^\/cart\/?$/)||!event.submitter?.matches('[name="checkout"], [data-cart-page-checkout]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    enqueue(()=>syncCart()).then(()=>location.assign('/checkout')).catch(error=>cartMessage(error.message));
  },true);
  // Ad entry activates the gift before returning shoppers to the full storefront.
  const entryUrl=new URL(location.href || 'https://www.botanicalinterests.com/');
  const giftEntry=script?.dataset.giftEntry!=='false'&&(entryUrl.searchParams.get('bi_offer')==='vault'||entryUrl.searchParams.get('view')===views.vault);
  if(giftEntry){
    enqueue(()=>syncCart('vault')).then(()=>{
      entryUrl.searchParams.delete('bi_offer');
      if(entryUrl.searchParams.get('view')===views.vault){entryUrl.searchParams.delete('view');entryUrl.pathname='/';}
      entryUrl.hash='';
      location.replace(entryUrl.toString());
    }).catch(error=>{cartMessage(error.message);const status=document.querySelector('[data-gift-entry-status]');if(status)status.textContent=error.message;});
    return;
  }
  function renderVaultBar(remaining,giftInCart) {
    let bar=document.querySelector('#bi-vault-bar');
    const active=state?.offer==='vault';
    document.body.classList.toggle('bi-vault-active',active);
    if(!active){bar?.remove();refreshChatPosition();return;}
    if(!bar){
      if(!document.querySelector('#bi-vault-bar-styles')){
        const styles=document.createElement('link');
        styles.id='bi-vault-bar-styles';styles.rel='stylesheet';
        styles.href=new URL('paid-offer-vault-bar.css?v=20260914-3',script.src).href;
        document.head.append(styles);
      }
      bar=document.createElement('aside');bar.id='bi-vault-bar';bar.setAttribute('aria-label','Mystery seed offer');
      bar.innerHTML='<div class="bi-vault-inner"><div class="bi-vault-copy" role="status"><strong>Mystery offer activated</strong><span></span></div><progress max="'+data.offers.vault.threshold+'" aria-label="Progress toward your mystery bundle"></progress><a href="/cart">View cart <span aria-hidden="true">→</span></a></div>';
      document.body.append(bar);
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(refreshChatPosition).observe(bar);
    }
    bar.querySelector('.bi-vault-copy span').textContent=remaining?`Spend ${money(remaining)} more to unlock your free mystery bundle.`:giftInCart?'Your mystery bundle has been added to your cart.':'$30 reached — your mystery bundle is being added.';
    const meter=bar.querySelector('progress');meter.value=data.offers.vault.threshold-remaining;
    meter.setAttribute('aria-valuetext',remaining?`${money(remaining)} remaining`:'$30 goal reached');
    refreshChatPosition();
  }
  if(root?.dataset.vaultLanding==='true'){
    enqueue(()=>syncCart('vault')).catch(error=>{$('offer-status').textContent=error.message;});
    return;
  }
  enqueue(()=>syncCart()).catch(error=>cartMessage(error.message));
  if(!root)return;
  const selected=new Map();
  let category='all',busy=false,showAll=false,heroVisible=true;
  const selectionKey=storageKey+'-selection-'+pageOffer;
  const detailsCache=new Map();
  let starterSelection=[];
  function saveSelection(){
    if(pageOffer==='vault')return;
    try{localStorage.setItem(selectionKey,JSON.stringify({version:1,updatedAt:Date.now(),items:[...selected].filter(([,q])=>q>0)}));}catch{}
  }
  function restoreSelection(){
    try{
      const saved=JSON.parse(localStorage.getItem(selectionKey));
      if(saved?.version!==1||!Array.isArray(saved.items)||!Number.isFinite(saved.updatedAt)||Date.now()-saved.updatedAt>7*86400000)return;
      let remaining=15;
      for(const entry of saved.items){
        if(!Array.isArray(entry))continue;
        const [id,quantity]=entry;
        if(selected.has(id)||!Number.isInteger(quantity)||quantity<1||!eligibleProducts().some(p=>p.id===id&&p.available))continue;
        const take=Math.min(quantity,remaining);if(take)selected.set(id,take);remaining-=take;
      }
    }catch{}
  }
  function showDialog(title,html){$('offer-dialog-title').textContent=title;$('offer-dialog-body').innerHTML=html;if(!$('offer-dialog').open)$('offer-dialog').showModal();}
  function showSelection(){
    const rows=eligibleProducts().filter(p=>selected.get(p.id)>0);
    showDialog('Your seed selection',rows.length?'<ul class="offer-selection-list">'+rows.map(p=>`<li><img src="${escape(p.image)}&width=100" alt="" width="54" height="54"><div><strong>${escape(p.title)}</strong><p>${selected.get(p.id)} ${selected.get(p.id)===1?'packet':'packets'}</p></div><button type="button" data-remove-selected="${p.id}">Remove</button></li>`).join('')+'</ul><button class="offer-button" type="button" data-continue-selection>Keep choosing</button>':'<p>No packets selected yet. Choose seeds or preview a starter mix.</p>');
  }
  function suggestedMix(kind){
    const pool=eligibleProducts().filter(p=>p.available),result=[];
    const add=(group,count)=>{const candidates=pool.filter(p=>group==='all'||p.categories.includes(group));for(let i=0;i<count&&candidates.length;i++)result.push(candidates[i%candidates.length]);};
    if(kind==='mixed'){add('vegetables',8);add('flowers',5);add('herbs',2);}else add(kind,15);
    if(result.length<15)add('all',15-result.length);
    return result;
  }
  async function productDetails(p){
    if(!detailsCache.has(p.id))detailsCache.set(p.id,api('products/'+p.handle+'?view=paid-offer-details').catch(error=>{detailsCache.delete(p.id);throw error}));
    return detailsCache.get(p.id);
  }
  function ratingLabel(text){
    const normalized=String(text||'').replace(/\s+/g,' ').trim();
    const match=normalized.match(/Rated ([\d.]+) out of 5 stars\s*(\d+)/i);
    return match?`${match[1]} / 5 (${match[2]} reviews)`:normalized;
  }
  function cardRating(text){
    const label=ratingLabel(text),match=label.match(/^([\d.]+) \/ 5 \((\d+) reviews\)$/);
    if(!match)return text?`<span class="offer-rating">${escape(label)}</span>`:'';
    const fill=Math.max(0,Math.min(100,Number(match[1])*20));
    return `<span class="offer-card-rating" role="img" aria-label="${escape(label)}"><span class="offer-stars" aria-hidden="true"><span>☆☆☆☆☆</span><span class="offer-stars-fill" style="width:${fill}%">★★★★★</span></span><span aria-hidden="true">(${match[2]})</span></span>`;
  }
  function factsHtml(details){return [['Sun',details.light],['Life cycle',details.life],['Height',details.height]].filter(([,v])=>v).map(([k,v])=>`<div><dt>${k}</dt><dd>${escape(v)}</dd></div>`).join('');}
  async function openProduct(id){
    const p=eligibleProducts().find(p=>p.id===id);if(!p)return;
    showDialog(p.title,'<p>Loading growing details...</p>');
    try{
      const d=await productDetails(p);
      if(!$('offer-dialog').open||$('offer-dialog-title').textContent!==p.title)return;
      $('offer-dialog-body').innerHTML=`<img class="offer-detail-image" src="${escape(p.image)}&width=480" alt="${escape(p.title)}"><p>${escape(d.description||'')}</p><dl class="offer-facts">${factsHtml(d)}</dl>${d.sowOutside?`<h3>When to sow outdoors</h3><p>${escape(d.sowOutside)}</p>`:''}${d.sowInside?`<h3>When to start indoors</h3><p>${escape(d.sowInside)}</p>`:''}${d.reviews?`<p class="offer-rating">${escape(ratingLabel(d.reviews))}</p>`:''}<a href="/products/${escape(p.handle)}" target="_blank" rel="noopener">Full product details and reviews</a>`;
    }catch{if($('offer-dialog-title').textContent===p.title)$('offer-dialog-body').innerHTML=`<p>Details could not load. Your selection is saved.</p><a href="/products/${escape(p.handle)}" target="_blank" rel="noopener">View product details</a>`;}
  }
  let factsObserver;
  const detailQueue=[];let detailRequests=0;
  function drainDetails(){
    while(detailRequests<3&&detailQueue.length){const {node,p}=detailQueue.shift();if(!node.isConnected)continue;detailRequests++;
      productDetails(p).then(d=>{if(!node.isConnected)return;node.innerHTML=cardRating(d.reviews);}).catch(()=>{}).finally(()=>{detailRequests--;drainDetails()});
    }
  }
  function observeProductFacts(){
    factsObserver?.disconnect();
    if(typeof IntersectionObserver==='undefined')return;
    factsObserver=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){factsObserver.unobserve(e.target);const p=eligibleProducts().find(p=>p.id===Number(e.target.dataset.productFacts));if(p)detailQueue.push({node:e.target,p});}drainDetails();},{rootMargin:'100px'});
    root.querySelectorAll('[data-product-facts]').forEach(node=>factsObserver.observe(node));
  }
  const eligibleProducts=()=>data.products.filter(p=>pageOffer==='vault'||data.offers[pageOffer].productIds.includes(String(p.id)));
  function selection(){
    const prices=[];
    for(const p of eligibleProducts())for(let i=0;i<(selected.get(p.id)||0);i++)prices.push(p.price);
    const total=prices.reduce((a,b)=>a+b,0);
    const savings=prices.length<15?0:pageOffer==='pack15'?data.offers.pack15.discountAmount:prices.sort((a,b)=>a-b).slice(0,5).reduce((a,b)=>a+b,0);
    return {count:prices.length,total,savings};
  }
  function renderSelection(){
    if(pageOffer==='vault')return;
    const s=selection(),remaining=15-s.count;
    $('selection-progress').textContent=`${s.count} of 15 packets selected`;
    $('selection-meter').value=s.count;
    $('selection-meter').setAttribute('aria-valuetext',`${s.count} of 15 packets selected`);
    $('selection-total').textContent=pageOffer==='pack15'?'15 packets for $30':s.count?(remaining?'Selected packet value: ':'Your total: ')+money(s.total-s.savings):'Choose 15. Pay for 10.';
    $('selection-saving').textContent=pageOffer==='pack15'?'$2 per packet':s.savings?`You save ${money(s.savings)}`:'5 free packets applied at 15';
    $('add-selection').disabled=busy||remaining>0;
    $('add-selection').textContent=busy?'Adding your seeds…':remaining?`Choose ${remaining} more`:pageOffer==='pack15'?'Add my 15-pack - $30':'Add my 15 packets';
    $('reset-selection').disabled=busy||!s.count;
    $('review-selection').disabled=busy||!s.count;
    root.querySelector('.offer-builder-bar').dataset.builderVisible=String(!heroVisible||s.count>0);
    saveSelection();
    root.querySelectorAll('[data-delta="1"]').forEach(b=>b.disabled=busy||s.count>=15);
    root.querySelectorAll('[data-delta="-1"]').forEach(b=>b.disabled=busy||!selected.get(Number(b.dataset.product)));
  }
  function renderGrid(){
    const query=$('seed-search').value.trim().toLowerCase();
    const matches=eligibleProducts().filter(p=>(category==='all'||p.categories.includes(category))&&p.title.toLowerCase().includes(query));
    const list=pageOffer==='vault'&&!showAll&&category==='all'&&!query?matches.slice(0,12):matches;
    if($('show-all-seeds')){$('show-all-seeds').hidden=list.length===matches.length;$('show-all-seeds').textContent=`Browse all ${matches.length} varieties`; }
    $('catalog-summary').textContent=`${list.length<matches.length?'Showing '+list.length+' of '+matches.length:list.length} varieties${pageOffer==='vault'?'':' | Choose any 15 packets'}`;
    $('seed-grid').innerHTML=list.map(p=>`<article class="offer-product"><button type="button" class="offer-product-image" data-details="${p.id}" aria-label="View details for ${escape(p.title)}"><img src="${escape(p.image)}&width=480" alt="${escape(p.title)}" width="360" height="360" loading="lazy"></button><div class="offer-product-body"><h3><button type="button" class="offer-product-details" data-details="${p.id}">${escape(p.title)}</button></h3><div class="offer-product-facts" data-product-facts="${p.id}"></div><p class="offer-product-price">${money(p.price)}<span>per packet</span></p>${pageOffer==='vault'?`<button class="offer-quick-add" data-add="${p.id}" type="button" ${busy?'disabled':''}>Add to cart</button>`:`<div class="offer-quantity"><button type="button" data-product="${p.id}" data-delta="-1" aria-label="Remove one ${escape(p.title)}">−</button><output aria-label="Selected quantity for ${escape(p.title)}">${selected.get(p.id)||0}</output><button type="button" data-product="${p.id}" data-delta="1" aria-label="Add one ${escape(p.title)}">+</button></div>`}</div></article>`).join('')||'<p class="offer-empty">No seeds match your search. Try another variety or category.</p>';
    renderSelection();observeProductFacts();
  }
  function setBusy(value){busy=value;renderSelection();root.querySelectorAll('[data-add]').forEach(b=>b.disabled=value);}
  async function addSeeds(chosen){
    if(busy)return;
    setBusy(true);$('offer-status').textContent='Adding your seeds…';
    try{
      await enqueue(async()=>{
        await Promise.all(chosen.map(async({product:p})=>{const current=await api('products/'+p.handle+'.js');const variant=current.variants.find(v=>v.id===p.variantId);if(!variant?.available)throw new Error(p.title+' is unavailable. Please choose another variety.');if(variant.price!==p.price)throw new Error(p.title+' has changed price. Please refresh the page before continuing.');}));
        await api('cart/add.js',{items:chosen.map(({product,quantity})=>({id:product.variantId,quantity}))});
        selected.clear();renderGrid();
        await syncCart(pageOffer);
      });
      $('offer-status').textContent='Your seeds are in your cart.';
      const trigger=document.querySelector('[data-panel-trigger="mini-cart"]');
      if(trigger)trigger.click();else location.assign('/cart');
    }catch(error){$('offer-status').textContent=error.message;}
    finally{setBusy(false);}
  }
  $('seed-search').addEventListener('input',()=>{if(data)renderGrid();});
  root.querySelector('.offer-filters').addEventListener('click',event=>{const button=event.target.closest('[data-category]');if(!button||!data)return;category=button.dataset.category;root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));renderGrid();});
  $('seed-grid').addEventListener('click',event=>{
    if(busy)return;
    const detail=event.target.closest('[data-details]');if(detail){openProduct(Number(detail.dataset.details));return;}
    const add=event.target.closest('[data-add]');
    if(add){const product=eligibleProducts().find(p=>p.id===Number(add.dataset.add));if(product)addSeeds([{product,quantity:1}]);return;}
    const button=event.target.closest('[data-product]');if(!button)return;
    const id=Number(button.dataset.product),delta=Number(button.dataset.delta);
    if(delta>0&&selection().count>=15)return;
    selected.set(id,Math.max(0,(selected.get(id)||0)+delta));
    button.closest('.offer-quantity').querySelector('output').textContent=selected.get(id);
    renderSelection();
  });
  $('reset-selection')?.addEventListener('click',()=>{if(!busy){selected.clear();$('offer-status').textContent='';renderGrid();}});
  $('add-selection')?.addEventListener('click',()=>{if(selection().count===15)addSeeds(eligibleProducts().filter(p=>selected.get(p.id)>0).map(product=>({product,quantity:selected.get(product.id)})));});
  $('review-selection')?.addEventListener('click',showSelection);
  $('close-offer-dialog').addEventListener('click',()=>$('offer-dialog').close());
  $('offer-dialog-body').addEventListener('click',event=>{
    const remove=event.target.closest('[data-remove-selected]');
    if(remove&&!busy){selected.delete(Number(remove.dataset.removeSelected));renderGrid();showSelection();$('close-offer-dialog').focus();}
    if(event.target.closest('[data-continue-selection]'))$('offer-dialog').close();
    if(event.target.closest('[data-use-starter]')&&!busy){selected.clear();for(const p of starterSelection)selected.set(p.id,(selected.get(p.id)||0)+1);category='all';$('seed-search').value='';root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category==='all')));renderGrid();$('offer-dialog').close();root.querySelector('.offer-starter-options').open=false;$('offer-status').textContent='Your starter mix is selected. Review or swap any packet before adding it to your cart.';}
  });
  root.querySelectorAll('[data-starter]').forEach(button=>button.addEventListener('click',()=>{
    if(!data||busy)return;starterSelection=suggestedMix(button.dataset.starter);
    const quantities=new Map();for(const p of starterSelection)quantities.set(p.id,(quantities.get(p.id)||0)+1);
    showDialog(button.textContent+' - 15 packets','<p>Suggested varieties to help you get started. Check the growing details for your garden; you can swap any packet after choosing this mix.</p><ul>'+[...quantities].map(([id,q])=>`<li>${q} x ${escape(data.products.find(p=>p.id===id).title)}</li>`).join('')+`</ul><button class="offer-button" type="button" data-use-starter>${selection().count?'Replace my selection with this mix':'Use this mix'}</button>`);
  }));
  $('show-all-seeds')?.addEventListener('click',()=>{showAll=true;renderGrid();});
  $('claim-gift')?.addEventListener('click',async()=>{
    if(busy)return;setBusy(true);$('claim-gift').disabled=true;
    try{await enqueue(()=>syncCart('vault'));document.querySelector('[data-panel-trigger="mini-cart"]')?.click();}
    catch(error){$('offer-status').textContent=error.message;}
    finally{setBusy(false);$('claim-gift').disabled=false;}
  });
  if(pageOffer!=='vault'&&typeof IntersectionObserver!=='undefined')new IntersectionObserver(entries=>{heroVisible=entries[0].isIntersecting&&entries[0].intersectionRatio>.2;if(data)renderSelection();},{threshold:[0,.2]}).observe(root.querySelector('.offer-hero'));
  else heroVisible=false;
  catalog().then(async()=>{restoreSelection();renderGrid();if(pageOffer==='vault')renderGiftProgress(await api('cart.js'));}).catch(error=>{$('offer-status').textContent=error.message;});
})();

